import { Grid, Typography } from '@mui/material';
import React from 'react';

import history from 'Lib/browserHistory';
import { useAppSelector } from 'Reducers/store/hooks';
import { getAPIConnectionFirmMappingFromId } from 'Selectors/apiFirms';
import ApiConnectionFirmDetails from 'SharedComponents/apiConnection/apiConnectionFirmDetails';
import ApiConnectionFirmUsers from 'SharedComponents/apiConnection/apiConnectionFirmUsers';

import type { ApiConnectionFirmProps } from '.';

export function ApiConnectionFirm (props: ApiConnectionFirmProps) {
    const {
        classes,
        match
    } = props;
    const apiConnFirmId = match.params.apiConnFirmId;
    const apiConnectionFirm = useAppSelector((state) => getAPIConnectionFirmMappingFromId(state, apiConnFirmId));
    React.useEffect(() => {
        //For real time messaging when the final user is removed
        if (apiConnectionFirm && apiConnectionFirm.apiFirm.IsDeleted) {
            history.push(`/admin/firms/${apiConnectionFirm.apiFirm.FirmId}`);
        }
    }, [apiConnectionFirm]);

    return (
        <Grid
            className={classes.root}
            container
            direction='column'
            spacing={0}
            wrap='nowrap'
        >
            {!apiConnectionFirm ?
                <Grid
                    alignItems='center'
                    className={classes.noSelectedConnection}
                    container
                    direction='column'
                    item
                    spacing={0}
                    wrap='nowrap'
                >
                    <Typography variant='body1'>Could not find selected API Connection for firm.</Typography>
                </Grid>
                : (
                    <>
                        <ApiConnectionFirmDetails
                            apiConnectionFirm={apiConnectionFirm}
                        />
                        <ApiConnectionFirmUsers
                            apiConnectionFirm={apiConnectionFirm}
                        />
                    </>
                )}
        </Grid>
    );
}